export const disablePointerEventsOnPDFRenderer = () => {
  /**
   * To allow the file drag and drop over the iframe
   * https://bugs.chromium.org/p/chromium/issues/detail?id=251718
   */
  const renderer = document.getElementById('pdfRenderer');
  if (renderer) renderer.style.pointerEvents = 'none';
};

export const enablePointerEventsOnPDFRenderer = () => {
  /**
   * To enable the user interaction again on iframe pdf renderer
   */
  const renderer = document.getElementById('pdfRenderer');
  if (renderer) renderer.style.pointerEvents = 'auto';
};
